import { render, staticRenderFns } from "./R-Tap.vue?vue&type=template&id=29ff23da&"
import script from "./R-Tap.vue?vue&type=script&lang=js&"
export * from "./R-Tap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports